import store from '@/store'
import moment from 'moment'
import axios from 'axios'

export class RepairsHelper {
  static getBlankRepair () {
    return {
      description: '',
      urgent: false,
      machine: '',
      machineId: null,
      timestampReported: moment().unix(),
      timestampFixed: 0,
      fixedByUser: null,
      fixedByUserId: null,
      reportedByUser: `${store.getters.user.firstName} ${store.getters.user.lastName}`,
      reportedByUserId: store.getters.user.uid,
      notes: ''
    }
  }

  static alertUrgentRepair (repairId) {
    console.log('alertUrgentRepair', repairId)
    axios.post(`${store.getters.apiUrl}/urgent-repair`, { repairId })
      .then(resp => console.log(resp))
      .catch(err => console.log('ERROR getting repair data', err))
  }
}
